import { render, staticRenderFns } from "./message.vue?vue&type=template&id=a6fa13a0&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&lang=css&"
import style1 from "./message.vue?vue&type=style&index=1&id=a6fa13a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fa13a0",
  null
  
)

export default component.exports